export type PaginationState = {
  current: number;
  pageSize: number;
};

/**
 * 根據總數動態生成分頁大小選項
 * @param total 總記錄數
 * @returns 分頁選項陣列
 */
export const getPageSizeOptions = (total: number): string[] => {
    const baseOptions = [10, 20, 50, 100];
    if (total <= 0) return ['10'];
    const options: number[] = [];
    
    for (const option of baseOptions) {
        if (option < total) {
            options.push(option);
        } else {
            break;
        }
    }
    
    if (total > 0) {
        options.push(total);
    }
    
    return options.map(String);
};

/**
 * - current 會重置為 resetCurrentTo（預設 1）
 * - pageSize 若 > total 或不在 options 內，重置成最小 options（預設 10）
 */
export const resetPaginationByTotal =
  (total: number, resetCurrentTo = 1, fallbackPageSize = 10) =>
  <T extends PaginationState>(prev: T): T => {
    const options = getPageSizeOptions(total).map(Number);
    const smallest = options[0] ?? fallbackPageSize;

    const shouldReset =
      total <= 0 ||
      prev.pageSize > total ||
      !options.includes(prev.pageSize);

    return {
      ...prev,
      current: resetCurrentTo,
      pageSize: shouldReset ? smallest : prev.pageSize,
    };
  };